// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap.css);"]);
// Module
exports.push([module.id, ".headline[data-v-a4527c74]{text-align:center;max-width:500px}.headline__title[data-v-a4527c74]{font-size:24px;font-weight:500;margin-top:20px;margin-bottom:10px}.headline__desc[data-v-a4527c74],.headline__title[data-v-a4527c74]{font-family:var(--font-main);color:var(--headline-color)}.headline__desc[data-v-a4527c74]{font-size:14px;font-weight:300;margin:0}", ""]);
// Exports
module.exports = exports;
